import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch } from 'vue'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'

interface Request {
  id: number
  type: string
  status: string
  data: any
  created_at: string
  closed_at: string | null
  operator_note: string | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Requests',
  setup(__props) {

const userStore = useUserStore()
const requests = ref<Request[]>([])

const getPhoneNumber = () => {
  return userStore.state?.context?.user?.phoneNumber?.substring(4) || ''
}

const fetchRequests = async () => {
  const phone = getPhoneNumber()
  if (!phone) return
  try {
    const { data } = await axios.get(`${API_BASE_URL}/requests?phone=${phone}`)
    requests.value = data
  } catch (e) {
    console.error('Error fetching requests:', e)
  }
}

const typeLabel = (type: string) => {
  return { tariff_change: 'Смена тарифа', roaming_enable: 'Включение роуминга', roaming_disable: 'Отключение роуминга' }[type] || type
}

const typeIcon = (type: string) => {
  return type === 'tariff_change' ? 'mdi-sim' : 'mdi-earth'
}

const statusColor = (status: string) => {
  return { open: 'warning', done: 'success', rejected: 'error' }[status] || 'grey'
}

const statusLabel = (status: string) => {
  return { open: 'В обработке', done: 'Выполнена', rejected: 'Отклонена' }[status] || status
}

const formatDate = (dt: string) => {
  if (!dt) return ''
  return new Date(dt).toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  })
}

watch(() => userStore.state.value, async (state) => {
  if (state === 'authenticated') {
    await fetchRequests()
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requests.value, (req) => {
                return (_openBlock(), _createBlock(_component_v_card, {
                  key: req.id,
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-body-1 font-weight-medium d-flex align-center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          color: statusColor(req.status),
                          class: "mr-2",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(typeIcon(req.type)), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"]),
                        _createTextVNode(" " + _toDisplayString(typeLabel(req.type)) + " ", 1),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_chip, {
                          color: statusColor(req.status),
                          size: "x-small",
                          variant: "flat"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(statusLabel(req.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatDate(req.created_at)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (req.operator_note)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          class: "text-body-2 pt-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(req.operator_note), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (requests.value.length === 0)
                ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, { class: "text-center text-medium-emphasis" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode(" Нет заявок ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})